// frontend/src/components/Footer.js

import React from 'react';

function Footer() {
  return (
    <footer className="footer mt-auto py-3 bg-light border-top">
      <div className="container text-center">
        <span className="text-muted">
          &copy; {new Date().getFullYear()} Mercado Jopoi. Creado por y para la comunidad universitaria.
        </span>
      </div>
    </footer>
  );
}

export default Footer;